import { getName } from "@rentiohq/shared-frontend/dist/redux/contact/contact.utils";
import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { sortBy } from "lodash";
import { IEnabledAccount } from "./EnabledAccountsSelect";

export const getDisplayName = (
  enabledAccount: IEnabledAccount,
  user: IUser,
) => {
  const isPersonal = user.personalAccountId === enabledAccount.id;

  const name = getName(enabledAccount, false);
  if (isPersonal) {
    return `${name} (${getLocalizedText("system.personal")})`;
  }

  return name;
};

export const getSortedAccounts = (
  options: IEnabledAccount[] = [],
  user: IUser,
) => {
  if (!user) return options;

  return sortBy(options, [
    enabledAccount => (user.personalAccountId === enabledAccount.id ? 0 : 1),
    enabledAccount => getDisplayName(enabledAccount, user),
  ]);
};
